module.exports = __webpack_public_path__ + "media/onecake-kitchenwiz.bbbfe911.mp4";